module.exports = __webpack_public_path__ + "static/media/co.eefa6c2c.svg";